/* eslint-disable monsterverse-rules/no-uuid-literals */
export const EntityAssets = {
  // The root entity used for the main world Mod, e.g. when loading a scene
  // Keep it small and unique as it will be used for uuid concatenation
  WorldRoot: "w",
  PocketWorld: "pw",

  PlayerSpawnPoints: "05f2fd59-96bd-411d-9765-d49fd96904fa",

  YellowPainter: "a835a920-1c4b-45cc-bd58-7d8649a66b29",
  BluePainter: "5fef48be-5146-4df4-8090-a4ee2f2a3d58",
  WhitePainter: "0b325747-5f5e-49ab-acda-16e68b12478c",
  RedPainter: "701ea860-1b5c-4133-b7bd-95b5f7080d0f",
  GreenPainter: "298db7b8-ff2c-4755-8bf5-16689e83b635",
  PurplePainter: "f3d62310-e212-4614-8e55-57161f2c24bb",
  LightRedPainter: "3e47821c-2f96-4bbd-854d-3f14fd482267",
  OrangePainter: "e797b8af-fcd5-48ac-a2d5-1e01279cae99",
  LightBluePainter: "9d116a65-800b-4b13-ac7f-d7514b69fef2",
  LightYellowPainter: "c0dc8c49-45e3-4e17-9124-b64ce8c0d9f4",
  BrownPainter: "5ea4da64-cdc7-4403-b140-a590befd8641",
  EmptyPainter: "36698037-33fc-4b32-bab4-fd3ecdd1cdf7",

  GlobalPlayground: "4a48219c-fb17-4148-8e8e-a29587c1af39",
  GlobalPlaygroundOpen: "13953051-d637-4673-aaec-ef445402b310",

  MonsterBall: "7w3X3Q6ojafmyjiZabg8K",
};
